import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {APP_BASE_HREF, CurrencyPipe} from '@angular/common';
import {NgxPermissionsModule} from 'ngx-permissions';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {OverlayModule} from '@angular/cdk/overlay';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';

import {UtilsService} from '@core/util-services/utils.service';
import {ErrorsModule} from '@core/errors';
import {AppRoutingModule} from './app-routing.module';
import {CoreModule} from '@core/core.module';
import {AuthenticationModule} from '@core/auth/authentication.module';
import {LayoutRefService} from '@core/util-services/layout/layout-ref.service';
import {PageConfigService} from '@core/util-services/page-config.service';
import {ClassInitService} from '@core/util-services/class-init.service';
import {LayoutConfigStorageService} from '@core/util-services/layout-config-storage.service';
import {MenuConfigService} from '@core/util-services/menu-config.service';
import {SplashScreenService} from '@core/util-services/splash-screen.service';
import {LayoutConfigService} from '@core/util-services/layout-config.service';
import {AppComponent} from './app.component';
import {SubheaderService} from '@core/util-services/layout/subheader.service';
import {MenuHorizontalService} from '@core/util-services/layout/menu-horizontal.service';
import {HeaderService} from '@core/util-services/layout/header.service';
import {ClipboardService} from '@core/util-services/clipboard.sevice';
import {AclService} from '@core/util-services/acl.service';
import {HttpAuthInterceptor} from '@core/auth/http-intercept.service';
import {AppConfigFactory} from '@service/config/app-config.factory';
import {AppConfigService} from '@service/config/app-config.service';
import {ContentService} from './constants/content.service';
import {SharedService} from '@core/util-services/shared.service';
import {ScriptLoaderService} from '@core/util-services/script-loader.service';
import {PartialsModule} from '@content/partials/partials.module';
import {NotificationService} from '@core/util-services/notification/notification.service';
import {NgxOtpInputModule} from 'ngx-otp-input';
import {ErrorInterceptor} from './interceptors/error.interceptor';
import { ReviewRoutingModule } from './shared/review/review-routing.module';
import { MatDialogModule } from '@angular/material/dialog';
@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserAnimationsModule,
        MatDialogModule,
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        PartialsModule,
        CoreModule,
        OverlayModule,
        AuthenticationModule,
        NgxPermissionsModule.forRoot(),
        NgbModule,
        NgxOtpInputModule,
        TranslateModule.forRoot(),
        MatProgressSpinnerModule,
        MatSnackBarModule,
        ErrorsModule,
        ReviewRoutingModule
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: AppConfigFactory,
            multi: true,
            deps: [HttpClient, AppConfigService, ContentService]
        },
        AclService,
        LayoutConfigService,
        LayoutConfigStorageService,
        LayoutRefService,
        MenuConfigService,
        PageConfigService,
        ClassInitService,
        ClipboardService,
        ScriptLoaderService,
        SplashScreenService,
        NotificationService,
        UtilsService,
        SharedService,
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, 
            useValue: {
                appearance: 'outline',
                subscriptSizing: 'dynamic'
            }
        },
        // template services
        SubheaderService,
        HeaderService,
        MenuHorizontalService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpAuthInterceptor,
            multi: true
        },
        {provide: APP_BASE_HREF, useValue: '/'},
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        CurrencyPipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
